export class Localization {
    masterItemId: string;
    cultureId: string;
    masterColumnName: string;
    masterText: string;
    localizationId: string;
    originalTableName: string;
}
